import React from 'react'
import { Box, IconButton, Tooltip } from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { useNavigate } from 'react-router';
import { tokens, radius, displayFont, monoFamily } from '../../../../../../../theme';
import { isIdentifier, displayValue, isEmptyValue, visibleRows } from './employeeFields';

// A read-only details card: heading + label/value rows, with an edit affordance
// that opens the edit form scoped to this section.
const InfoCard = ({ headingText, data, employeeId, name }) => {
  const navigate = useNavigate();
  const handleEdit = () => {
    navigate(`/app/edit-employee-details/${employeeId}`, { state: { data, headingText, name } });
  };

  // "Profile Image" rows aren't useful as text — skip them in the value list.
  const rows = visibleRows(data);

  return (
    <Box sx={{ background: tokens.card, border: `1px solid ${tokens.border}`, borderRadius: `${radius.card}px`, p: "1.5rem", height: "100%" }}>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: "1.25rem" }}>
        <Box sx={{ fontFamily: displayFont, fontSize: "1.0625rem", fontWeight: 700, color: tokens.text }}>
          {headingText}
        </Box>
        <Tooltip title="Edit details">
          <IconButton size="small" onClick={handleEdit} sx={{ color: tokens.textMuted, border: `1px solid ${tokens.border}`, borderRadius: "8px" }}>
            <EditOutlinedIcon sx={{ fontSize: "1rem" }} />
          </IconButton>
        </Tooltip>
      </Box>
      <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "repeat(2, 1fr)" }, gap: "1.25rem" }}>
        {rows.map((item, i) => {
          const mono = isIdentifier(item.field);
          const empty = isEmptyValue(item.value);
          return (
            <Box key={i}>
              {/* The book's field label: 11px small caps in plum. At 13px and
                  regular weight it competed with the value beneath it. */}
              <Box
                sx={{
                  fontSize: "0.6875rem",
                  fontWeight: 600,
                  letterSpacing: "0.06em",
                  textTransform: "uppercase",
                  color: tokens.textMuted,
                  mb: "0.3125rem",
                }}
              >
                {item.label}
              </Box>
              <Box
                sx={{
                  // Identifiers are monospace, always: these are read character
                  // by character and checked against another screen, and a
                  // proportional font makes 1/l and 0/O ambiguous exactly where
                  // it matters. A dash is not an identifier, so it stays prose.
                  fontFamily: mono && !empty ? monoFamily : "inherit",
                  fontSize: mono && !empty ? "0.8125rem" : "0.875rem",
                  color: empty ? tokens.textPlaceholder : tokens.text,
                  wordBreak: "break-word",
                }}
              >
                {displayValue(item.value)}
              </Box>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default InfoCard;
